// extracted by mini-css-extract-plugin
export default {"ecImagePlusTextCollectionCarousel":"styles_ecImagePlusTextCollectionCarousel__nP3ZF","swiper":"styles_swiper__AQbia","swiper-wrapper":"styles_swiper-wrapper__nd5d1"};